export default __webpack_public_path__ + "static/kiln-5-d769b409a2ec6648a57bbb4a8d650de4.jpg";